import Vue from 'vue'
import Package from './Package'
import PackageUpdate from './PackageUpdate'

import cloneDeep from 'lodash/cloneDeep'

export default {
  state: {
    packages: [],
    installed: null,
    in_loading: {},
    language: '',
    loading: false,
    error: null,
    active: ''
  },
  mutations: {
    PACKAGES_SET (state, packages) {
      state.packages.splice(0, state.packages.length)
      packages.forEach(pckg => state.packages.push(pckg))
    },
    PACKAGES_SET_INSTALLED (state, payload) {
      if (typeof payload !== 'object') return
      state.installed = {}
      Object.keys(payload).forEach(key => {
        Vue.set(state.installed, key, payload[key])
      })
    },
    PACKAGES_SET_IN_LOADING (state, payload) {
      if (typeof payload !== 'object') return
      state.in_loading = {}
      Object.keys(payload).forEach(key => {
        Vue.set(state.in_loading, key, payload[key])
      })
    },
    PACKAGES_SET_LANGUAGE (state, language) { state.language = language },
    PACKAGES_SET_ACTIVE (state, id) { state.active = id },
    PACKAGES_SET_LOADING (state, value) { state.loading = value },
    PACKAGES_SET_ERROR (state, err) { state.error = err },
    PACKAGES_SET_ITEM (state, { index, item }) { state.packages.splice(index, 1, item) },
    PACKAGES_ADD (state, item) { state.packages.push(item) },
    PACKAGES_UPDATE (state, { index, item }) {
      Object.keys(item).forEach(key => {
        Vue.set(state.packages[index], key, item[key])
      })
      Vue.set(state.packages, index, state.packages[index])
    }
  },
  actions: {
    PACKAGES_ALL ({ commit }) {
      commit('PACKAGES_SET_LOADING', true)
      commit('PACKAGES_SET_ERROR', null)
      return Vue.api.packages().all()
        .then(data => {
          let packages = []
          Object.keys(data).forEach(consumer => {
            Object.keys(data[consumer]).forEach(type => {
              Object.keys(data[consumer][type]).forEach(id => {
                let options = data[consumer][type][id]
                packages.push(new Package(consumer, type, id, options))
              })
            })
          })
          commit('PACKAGES_SET', packages)
          commit('PACKAGES_SET_LOADING', false)
        })
        .catch(err => {
          commit('PACKAGES_SET_LOADING', false)
          commit('PACKAGES_SET_ERROR', err)
          throw err
        })
    },
    PACKAGES_UPDATE ({ commit, state }, { consumer, type, id, item }) {
      return PackageUpdate(consumer, type, id, item)
        .then(updatedItem => {
          let index = state.packages.findIndex(pckg => {
            return pckg.consumer === consumer && pckg.type === type && pckg.id === updatedItem.id
          })
          updatedItem = new Package(consumer, type, updatedItem.id, {
            ...updatedItem,
            owned: true,
            installed: null,
            in_loading: null,
            acl: { update: true, read: true, delete: true }
          })
          if (index === -1) {
            commit('PACKAGES_ADD', updatedItem)
          } else {
            commit('PACKAGES_UPDATE', { index, item: updatedItem })
          }
          return true
        })
    }
  },
  getters: {
    PACKAGES_LOADING: (state) => state.loading,
    PACKAGES_ERROR: (state) => state.error,
    PACKAGES_ACTIVE: (state) => state.active,
    PACKAGES_BY_CONSUMER_TYPE (state) {
      return (consumer, type) => {
        return state.packages
          .filter(pckg => {
            if (state.language) {
              let check = pckg.versions.some(version => version.startsWith(state.language))
              if (check === false) return false
            }
            return pckg.consumer === consumer && pckg.type === type
          })
          .map(item => {
            if (!state.installed) return item
            let ret = cloneDeep(item)
            ret.installed = typeof state.installed[item.id] !== 'undefined'
            ret.loading = state.in_loading[item.id]
            if (ret.installed && state.installed[item.id].source) {
              ret.source = cloneDeep(state.installed[item.id].source)
              ret.savedVersion = cloneDeep(state.installed[item.id].version)
            }
            return ret
          })
      }
    },
    PACKAGES_ITEM (state) {
      return (consumer, type, id) => {
        return state.packages.find(pckg => {
          return pckg.consumer === consumer && pckg.type === type && pckg.id === id
        })
      }
    },
    PACKAGES_CONSUMERS (state) {
      let consumers = []
      state.packages.forEach(pack => {
        if (consumers.indexOf(pack.consumer) === -1) consumers.push(pack.consumer)
      })
      return consumers
    },
    PACKAGES_TYPES_BY_CONSUMER (state) {
      return (consumer) => {
        let types = []
        state.packages.forEach(pack => {
          if (pack.consumer === consumer && types.indexOf(pack.type) === -1) {
            types.push(pack.type)
          }
        })
        return types
      }
    }
  }
}
